import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { apolloClient } from "./apolloClient";
import { purgeLegacyInputData } from "./lib/purgeLegacyStorage";
import "./i18n";
import "./styles/globals.css";

// RW-60: remove any contact personal data left in localStorage by the pre-fix build, before the
// app mounts. Form state now lives in sessionStorage (see useSessionStorage / ADR-RW-60-0001).
purgeLegacyInputData();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
);
